import React from "react";
import OrderFollowup from "../containers/OrderFollowup";
import domScrollTo from "../utils/domScrollTo";

export default function OrderStatusScreen() {
  // o goTo usa history.replace: sem isso a tela abre no scroll do checkout
  React.useEffect(() => {
    domScrollTo(0, "auto");
  }, []);

  return <OrderFollowup />;
}
